import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';

const nav = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About' },
  { to: '/tourpackage', label: 'Tour Package' },
  // { to: '/contact', label: 'Contact' },
  { to:'/visa-assistance', label: 'Visa Assistance' }
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-gray-100">
      <div className="container flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 text-primary text-2xl font-bold">
          ONE<span className="text-gray-900">ZONE TRAVELS</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} className={({isActive}) => `text-sm font-medium hover:text-primary ${isActive? 'text-primary':'text-gray-700'}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <Link to="/contact" className="btn-primary rounded-full px-5 h-10 inline-flex items-center gap-2 shadow-md shadow-primary/30 hover:shadow-lg hover:-translate-y-0.5 transition">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="-ml-1"><path d="M22 16.92v2a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h2a2 2 0 0 1 2 1.72c.12.9.32 1.78.6 2.63a2 2 0 0 1-.45 2.11L7.09 9.91a16 16 0 0 0 6 6l1.45-1.12a2 2 0 0 1 2.11-.45c.85.28 1.73.48 2.63.6A2 2 0 0 1 22 16.92Z" stroke="currentColor" strokeWidth="1.6"/></svg>
            <span>Contact</span>
          </Link>
          {/* <button className="btn-primary">Sign in</button> */}
        </div>
        <button className="md:hidden p-2" onClick={() => setOpen(v=>!v)} aria-label="menu">
          <span className="i-bar w-6 h-0.5 bg-gray-900 block mb-1"></span>
          <span className="i-bar w-6 h-0.5 bg-gray-900 block mb-1"></span>
          <span className="i-bar w-6 h-0.5 bg-gray-900 block"></span>
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-gray-100 bg-white">
          <div className="container py-3 flex flex-col gap-3">
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={()=>setOpen(false)} className={({isActive}) => `py-1 ${isActive? 'text-primary':'text-gray-700'}`}>{n.label}</NavLink>
            ))}
            <Link to="/contact" onClick={()=>setOpen(false)} className="btn-primary w-full">Contact</Link>
            {/* <button className="btn-primary w-full">Sign in</button> */}
          </div>
        </div>
      )}
    </header>
  );
}
